<script>
  import PreviewShapes from "./previewShapes.svelte"
  import Button from "../../Shared/Button.svelte"
  import TextEditorMenu from "./textEditorMenu.svelte"
  import ShapeEditorMenu from "./shapeEditorMenu.svelte"
  import ImageEditorMenu from "./imageEditorMenu.svelte"
  export let operation
  export let deleteSingleLayer
  export let LayerDeleteObj
</script>

<slot />
{#if operation.active}
  <svelte:component
    this={operation.type == "text" ? TextEditorMenu : operation.type == "image" ? ImageEditorMenu : ShapeEditorMenu}
    bind:operation
    on:keydown={(event) => {
      if (event.key === "Delete") {
        deleteSingleLayer = true
        LayerDeleteObj = { value: operation.value, id: operation.id }
      }
      if (event.target.nodeName == "BODY") {
        let step = event.ctrlKey ? 10 : 1
        if (event.key === "ArrowRight" || event.key === "ArrowLeft" || event.key === "ArrowUp" || event.key === "ArrowDown") {
          event.preventDefault()
        }
        if (event.key === "ArrowRight") {
          operation.x = operation.x + step
        } else if (event.key === "ArrowLeft") {
          operation.x = operation.x - step
        } else if (event.key === "ArrowUp") {
          operation.y = operation.y - step
          operation.inputY = operation.inputY + step
        } else if (event.key === "ArrowDown") {
          operation.y = operation.y + step
          operation.inputY = operation.inputY - step
        }
      }
    }}
    on:click
  />
{/if}

<!-- on:keydown={(event) => {
      if (event.target.nodeName == "BODY") {
        let step = event.ctrlKey ? 10 : 1
        if (event.key === "ArrowRight" || event.key === "ArrowLeft" || event.key === "ArrowUp" || event.key === "ArrowDown") {
          event.preventDefault()
        }
        if (event.key === "ArrowRight") {
          operation.x = operation.x + step
        } else if (event.key === "ArrowLeft") {
          operation.x = operation.x - step
        } else if (event.key === "ArrowUp") {
          operation.y = operation.y - step
          operation.inputY = operation.inputY + step
        } else if (event.key === "ArrowDown") {
          operation.y = operation.y + step
          operation.inputY = operation.inputY - step
        }
      }
    }} -->
